import React from 'react';
import { useTranslation } from 'react-i18next';
import { MessageSquare, Target, BarChart, ArrowRight } from 'lucide-react';

export default function LandingHowItWorks() {
  const { t } = useTranslation();
  const steps = [
    { step: '01', title: t('landing.howItWorks.step1.title'), description: t('landing.howItWorks.step1.description'), icon: MessageSquare },
    { step: '02', title: t('landing.howItWorks.step2.title'), description: t('landing.howItWorks.step2.description'), icon: Target },
    { step: '03', title: t('landing.howItWorks.step3.title'), description: t('landing.howItWorks.step3.description'), icon: BarChart },
  ];
  return (
    <section id="how-it-works" className="py-24 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">{t('landing.howItWorks.title')}</h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">{t('landing.howItWorks.subtitle')}</p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((item) => (
            <div key={item.step} className="relative group">
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-200 hover:shadow-xl transition-all duration-300 h-full">
                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-xl bg-primary text-primary-foreground mb-6 group-hover:scale-110 transition-transform`}>
                  <item.icon className="w-8 h-8" />
                </div>
                <div className="text-sm font-bold text-slate-400 mb-2">{t('landing.howItWorks.step1.label').replace('01', item.step)}</div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">{item.title}</h3>
                <p className="text-slate-600 leading-relaxed">{item.description}</p>
              </div>
              {item.step !== '03' && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <ArrowRight className="w-8 h-8 text-slate-300" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
